// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --text-primary: #121212;
  --text-secondary: #606060;
  --text-ticker: #2b3c8f;
  --text-instrument: #1e1f2f;
  --text-down-color: #b71c15;
  --text-up-color: #1c7d45;
  --text-unchg-color: #7f7f7f;
  --text-subheader: #1e1f2f;
  --accent-link: #007aff;
  --text-link: #000000;
  --border-primary: #bfbfbf;
  --border-secondary: #bdbdbd;
  --border-tertiary: #e0e0e0;
  --border-line: #121212;
  --surface-down-light: #ffbcbc;
  --accent-brand: #d44500;
  --accent-secondary: #7f7f7f;
  --accent-primary: #1e1f2f;
  --row-light: #ffffff;
  --row-dark: #f7f7f7;
  --text-invert: #ffffff;
  --heatmap-up-6: #085026;
  --heatmap-up-5: #11773c;
  --heatmap-up-4: #188647;
  --heatmap-up-3: #219653;
  --heatmap-up-2: #34b66b;
  --heatmap-up-1: #99ddb6;
  --heatmap-no-chg: #dfdfdf;
  --heatmap-down-1: #ffbcbc;
  --heatmap-down-2: #f18989;
  --heatmap-down-3: #e73838;
  --heatmap-down-4: #d81f1f;
  --heatmap-down-5: #b21b1b;
  --heatmap-down-6: #9e1111;
  --heatmap-range-1: #d5d8e9;
  --heatmap-range-2: #aab1d2;
  --heatmap-range-3: #808abc;
  --heatmap-range-4: #5563a5;
  --heatmap-range-5: #2b3c8f;
  --surface-default: #d44500;
  --surface-hover: #bf5700;
  --surface-disabled: #9f9f9f;
  --surface-loading: #bf5700;
  --heatmap-range-6: #223072;
  --heatmap-range-7: #1a2456;
  --heatmap-range-8: #111839;
  --heatmap-range-9: #090c1d;
  --surface-primary: #ffffff;
  --border-input: #bfbfbf;
  --text-input-2: #1e1f2f;
  --text-input-placeholder: #7f7f7f;
  --surface-secondary: #e5e5e5;
  --surface-invert: #1e1f2f;
  --surface-tertiary: #f9f9f9;
  --text-label: #7f7f7f;
  --accent-up: #219653;
  --accent-down: #d32f2f;
  --surface-brand: #121212;
  --tab-filter-off-surface: #efefef;
  --text-disable: #9f9f9f;
  --input-text: #121212;
  --input-border: #bfbfbf;
  --box-shadow-primary: #1212121a;
  --text-tertiary: #3c3c432e;

  --asset-cash-dark: #8b73b6;
  --chart-ta-1: #0080ff;
  --chart-ta-2: #aa2211;
  --chart-ta-3: #9933ff;
  --chart-ta-4: #ffb0b0;
  --chart-ta-5: #449999;
  --chart-ta-6: #ff3399;
  --chart-ta-7: #ff9900;
  --chart-ta-8: #9aa1a9;
  --chart-compare-1: #2196f3;
  --chart-compare-2: #ff9800;
  --chart-compare-3: #4caf50;
  --chart-compare-4: #e91e63;
  --chart-compare-5: #9c27b0;
  --chart-compare-6: #00bcd4;
  --chart-compare-7: #ff5722;
  --chart-compare-8: #8bc34a;
  --chart-drawing-default: #f44336;
  --surface-quinary: #efefef;
  --surface-senary: #fafafa;
  --border-quaternary: #efefef;
  --surface-quaternary: #f7f7f7;
}

[data-theme='direct'] {
  --color-brand: #d44500;
  --color-brand-hover: rgba(212, 69, 0, 0.06);
  --color-brand-hover2: #f9e2d6;
  --chart-primary: #eb6e08;
  --chart-secondary: #f9dc5c;
  --chart-tertiary: #28ade3;
  --chart-quaternary: #00c1b5;
  --chart-quinary: #f16257;
  --chart-senary: #084059;
  --chart-septenary: #fcc79c;
  --tab-filter-off-surface2: #f9e2d6;
  --illustration-tertiary1: #f9e2d6;
  --illustration-tertiary2: #f2c1a6;
  --illustration-tertiary3: #eca57e;
  --border-primary-brand: #eb6e08;
}

[data-theme='potter'] {
  --color-brand: #00c1b5;
  --color-brand-hover: rgba(80, 189, 181, 0.06);
  --color-brand-hover2: #dcf2f0;
  --chart-primary: #00c1b5;
  --chart-secondary: #084059;
  --chart-tertiary: #f16257;
  --chart-quaternary: #f9dc5c;
  --chart-quinary: #28ade3;
  --chart-senary: #eb6e08;
  --chart-septenary: #b5e3df;
  --tab-filter-off-surface2: #d5f6e3;
  --illustration-tertiary1: #dcf2f0;
  --illustration-tertiary2: #a2efe8;
  --illustration-tertiary3: #7fede3;
  --border-primary-brand: #00c1b5;
}

[data-theme='desktop'] {
  --color-brand: #007ab2;
  --color-brand-hover: rgba(40, 173, 227, 0.06);
  --color-brand-hover2: #ccefff;
  --chart-primary: #28ade3;
  --chart-secondary: #084059;
  --chart-tertiary: #f9dc5c;
  --chart-quaternary: #00c1b5;
  --chart-quinary: #f16257;
  --chart-senary: #eb6e08;
  --chart-septenary: #99dfff;
  --tab-filter-off-surface2: #d8dcf3;
  --illustration-tertiary1: #ccefff;
  --illustration-tertiary2: #a2d8f0;
  --illustration-tertiary3: #7ecbee;
  --border-primary-brand: #008bca;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Layout/Layout.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;;EAE1B,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;EAChC,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,+BAA+B;AACjC","sourcesContent":[":root {\n  --text-primary: #121212;\n  --text-secondary: #606060;\n  --text-ticker: #2b3c8f;\n  --text-instrument: #1e1f2f;\n  --text-down-color: #b71c15;\n  --text-up-color: #1c7d45;\n  --text-unchg-color: #7f7f7f;\n  --text-subheader: #1e1f2f;\n  --accent-link: #007aff;\n  --text-link: #000000;\n  --border-primary: #bfbfbf;\n  --border-secondary: #bdbdbd;\n  --border-tertiary: #e0e0e0;\n  --border-line: #121212;\n  --surface-down-light: #ffbcbc;\n  --accent-brand: #d44500;\n  --accent-secondary: #7f7f7f;\n  --accent-primary: #1e1f2f;\n  --row-light: #ffffff;\n  --row-dark: #f7f7f7;\n  --text-invert: #ffffff;\n  --heatmap-up-6: #085026;\n  --heatmap-up-5: #11773c;\n  --heatmap-up-4: #188647;\n  --heatmap-up-3: #219653;\n  --heatmap-up-2: #34b66b;\n  --heatmap-up-1: #99ddb6;\n  --heatmap-no-chg: #dfdfdf;\n  --heatmap-down-1: #ffbcbc;\n  --heatmap-down-2: #f18989;\n  --heatmap-down-3: #e73838;\n  --heatmap-down-4: #d81f1f;\n  --heatmap-down-5: #b21b1b;\n  --heatmap-down-6: #9e1111;\n  --heatmap-range-1: #d5d8e9;\n  --heatmap-range-2: #aab1d2;\n  --heatmap-range-3: #808abc;\n  --heatmap-range-4: #5563a5;\n  --heatmap-range-5: #2b3c8f;\n  --surface-default: #d44500;\n  --surface-hover: #bf5700;\n  --surface-disabled: #9f9f9f;\n  --surface-loading: #bf5700;\n  --heatmap-range-6: #223072;\n  --heatmap-range-7: #1a2456;\n  --heatmap-range-8: #111839;\n  --heatmap-range-9: #090c1d;\n  --surface-primary: #ffffff;\n  --border-input: #bfbfbf;\n  --text-input-2: #1e1f2f;\n  --text-input-placeholder: #7f7f7f;\n  --surface-secondary: #e5e5e5;\n  --surface-invert: #1e1f2f;\n  --surface-tertiary: #f9f9f9;\n  --text-label: #7f7f7f;\n  --accent-up: #219653;\n  --accent-down: #d32f2f;\n  --surface-brand: #121212;\n  --tab-filter-off-surface: #efefef;\n  --text-disable: #9f9f9f;\n  --input-text: #121212;\n  --input-border: #bfbfbf;\n  --box-shadow-primary: #1212121a;\n  --text-tertiary: #3c3c432e;\n\n  --asset-cash-dark: #8b73b6;\n  --chart-ta-1: #0080ff;\n  --chart-ta-2: #aa2211;\n  --chart-ta-3: #9933ff;\n  --chart-ta-4: #ffb0b0;\n  --chart-ta-5: #449999;\n  --chart-ta-6: #ff3399;\n  --chart-ta-7: #ff9900;\n  --chart-ta-8: #9aa1a9;\n  --chart-compare-1: #2196f3;\n  --chart-compare-2: #ff9800;\n  --chart-compare-3: #4caf50;\n  --chart-compare-4: #e91e63;\n  --chart-compare-5: #9c27b0;\n  --chart-compare-6: #00bcd4;\n  --chart-compare-7: #ff5722;\n  --chart-compare-8: #8bc34a;\n  --chart-drawing-default: #f44336;\n  --surface-quinary: #efefef;\n  --surface-senary: #fafafa;\n  --border-quaternary: #efefef;\n  --surface-quaternary: #f7f7f7;\n}\n\n[data-theme='direct'] {\n  --color-brand: #d44500;\n  --color-brand-hover: rgba(212, 69, 0, 0.06);\n  --color-brand-hover2: #f9e2d6;\n  --chart-primary: #eb6e08;\n  --chart-secondary: #f9dc5c;\n  --chart-tertiary: #28ade3;\n  --chart-quaternary: #00c1b5;\n  --chart-quinary: #f16257;\n  --chart-senary: #084059;\n  --chart-septenary: #fcc79c;\n  --tab-filter-off-surface2: #f9e2d6;\n  --illustration-tertiary1: #f9e2d6;\n  --illustration-tertiary2: #f2c1a6;\n  --illustration-tertiary3: #eca57e;\n  --border-primary-brand: #eb6e08;\n}\n\n[data-theme='potter'] {\n  --color-brand: #00c1b5;\n  --color-brand-hover: rgba(80, 189, 181, 0.06);\n  --color-brand-hover2: #dcf2f0;\n  --chart-primary: #00c1b5;\n  --chart-secondary: #084059;\n  --chart-tertiary: #f16257;\n  --chart-quaternary: #f9dc5c;\n  --chart-quinary: #28ade3;\n  --chart-senary: #eb6e08;\n  --chart-septenary: #b5e3df;\n  --tab-filter-off-surface2: #d5f6e3;\n  --illustration-tertiary1: #dcf2f0;\n  --illustration-tertiary2: #a2efe8;\n  --illustration-tertiary3: #7fede3;\n  --border-primary-brand: #00c1b5;\n}\n\n[data-theme='desktop'] {\n  --color-brand: #007ab2;\n  --color-brand-hover: rgba(40, 173, 227, 0.06);\n  --color-brand-hover2: #ccefff;\n  --chart-primary: #28ade3;\n  --chart-secondary: #084059;\n  --chart-tertiary: #f9dc5c;\n  --chart-quaternary: #00c1b5;\n  --chart-quinary: #f16257;\n  --chart-senary: #eb6e08;\n  --chart-septenary: #99dfff;\n  --tab-filter-off-surface2: #d8dcf3;\n  --illustration-tertiary1: #ccefff;\n  --illustration-tertiary2: #a2d8f0;\n  --illustration-tertiary3: #7ecbee;\n  --border-primary-brand: #008bca;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
